require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-person-of-color-in-tech.json") })
        }
      }, "path---blog-person-of-color-in-tech");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-person-of-color-in-tech!./.cache/json/blog-person-of-color-in-tech.json
// module id = 1035
// module chunks = 231608221292675